import { Component, OnInit, Sanitizer } from '@angular/core';
import { Router } from '@angular/router';
import { USER_ROLES, USER_STATUS } from 'src/app/enums/enums';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
declare var $: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  users:        User[];
  status:       string;
  identity:     any;
  token:        string;
  user:         User;
  loading:      boolean;
  isSubmitting: boolean;
  isDeleting:   boolean;
  isUpdating:   boolean;
  page:         number = 1;
  pageSize:     number = 10;
  userRoles:    USER_ROLES[] = Object.values(USER_ROLES);
  loggedUser:   User;

  constructor(
    private _userService: UserService,
    private _sanitizer: Sanitizer,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    $('html,body').scrollTop(0);
    this.user = this.getNewUser();
    this.loggedUser = this.getNewUser();
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    if (!this.identity || !this.token)
      this._router.navigate(['/iniciar-sesion']);
    else 
      this.getLoggedUser();
  }

  getLoggedUser(): void {
    this.loading = true;
    this._userService.getLoggedUser(this.identity.id).subscribe(
      res => {
        if (!res.user) {
          this.status = 'error';
        } else {
          this.loggedUser = res.user;
          this.status = 'ok';
          if (this.loggedUser.role !== USER_ROLES.SUPER_ADMIN) {
            this.userRoles.filter(role => role === USER_ROLES.SUPER_ADMIN);
          }
        }
        this.loading = false;
        this.listarUsuarios();
      },
      err => this.onError(err)
    );
  }

  async listarUsuarios(): Promise<void> {
    if (!this.loading) {
      this.loading = true;
      try {
        const res = await this._userService.listUsers().toPromise();
        if (res.users.length <= 0) {
          alert('No hay usuarios para mostrar');
          this.users = [];
        } else {
          this.users = res.users;
          this.users = this.filterByRole(this.users);
          this.users.push(...this.filterByRole(this.users));
        }
        this.status = 'ok';
        this.loading = false;
      } catch (error) {
        this.onError(error);
      }
    }
  }

  async agregarUsuario(): Promise<void> {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      try {
        const res = await this._userService.addUser(this.user).toPromise();
        if (!res.user) {
          this.status = 'error';
        } else {
          this.users.push({ ...res.user });
          this.clearUser();
          this.status = 'ok';
        }
        this.isSubmitting = false;
      } catch (error) {
        this.onError(error);
      }
    }
  }

  clearUser():void {
    this.user = this.getNewUser();
  }

  setUser(user: User): void {
    this.user = new User(
      user.id,
      user.name,
      user.lastname,
      user.email,
      user.password,
      user.role,
      user.status
    );
  }

  filterByRole(users: User[]): User[] {
    if (this.loggedUser.role === USER_ROLES.SUPER_ADMIN) {
      return users;
    } else {
      return users.filter(user => user.role !== USER_ROLES.SUPER_ADMIN);
    }
  }

  getNewUser(): User {
    return new User('', '', '', '', '', USER_ROLES.COMUNICATIONS, USER_STATUS.ACTIVE);
  }

  onError(error: any): void {
    let errorMessage = error;
    alert("Error al ejecutar la acción");
    if (errorMessage != null) {
      this.status = 'error';
    }
    this.loading = false;
    this.isSubmitting = false;
    this.isDeleting = false;
    this.isUpdating = false;
  }
}
